import script from "./PackingSlips.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackingSlips.vue?vue&type=script&setup=true&lang=ts"

import "./PackingSlips.vue?vue&type=style&index=0&id=498f65db&lang=scss"

const __exports__ = script;

export default __exports__